export default __webpack_public_path__ + "static/media/17.9ad23b31.png";